import authrequest from '@/utils/authrequest'

// 当前用户的消息列表
export function getMyNotifications(params) {
  return authrequest({
    url: '/api/app/notification/my-list',
    method: 'get',
    params
  })
}

// 当前用户未读数（顶栏轮询）
export function getNotificationUnreadCount() {
  return authrequest({
    url: '/api/app/notification/unread-count',
    method: 'get'
  })
}

// 标记一条已读
export function markNotificationAsRead(id) {
  return authrequest({
    url: '/api/app/notification/mark-as-read',
    method: 'post',
    params: { id }
  })
}

// 当前用户全部标记已读
export function markAllNotificationsAsRead() {
  return authrequest({
    url: '/api/app/notification/mark-all-as-read',
    method: 'post'
  })
}

// 当前用户标记一条已处理
export function markNotificationAsResolved(id) {
  return authrequest({
    url: '/api/app/notification/mark-as-resolved',
    method: 'post',
    params: { id }
  })
}

// 当前用户忽略一条
export function dismissNotification(id) {
  return authrequest({
    url: '/api/app/notification/dismiss',
    method: 'post',
    params: { id }
  })
}

// 级别枚举（与后端 NotificationSeverity 对齐）
export const NotificationSeverity = {
  Critical: 1,
  Major: 2,
  Minor: 3,
  Info: 4
}

// 状态枚举（与后端 NotificationReceiverStatus 对齐）
export const NotificationStatus = {
  Unread: 0,
  Read: 1,
  Resolved: 2,
  Dismissed: 3
}

// 级别展示元信息：颜色/标签/排序权重
export const SeverityMeta = {
  [NotificationSeverity.Critical]: { label: 'P0 紧急', color: '#f56c6c', tagType: 'danger', weight: 4 },
  [NotificationSeverity.Major]: { label: 'P1 重要', color: '#e6a23c', tagType: 'warning', weight: 3 },
  [NotificationSeverity.Minor]: { label: 'P2 一般', color: '#909399', tagType: 'info', weight: 2 },
  [NotificationSeverity.Info]: { label: 'P3 提示', color: '#909399', tagType: '', weight: 1 }
}

export const StatusMeta = {
  [NotificationStatus.Unread]: { label: '未读', tagType: 'danger' },
  [NotificationStatus.Read]: { label: '已读', tagType: 'info' },
  [NotificationStatus.Resolved]: { label: '已处理', tagType: 'success' },
  [NotificationStatus.Dismissed]: { label: '已忽略', tagType: '' }
}
